import { useQuery } from './use-query';

function useQueryBuilder(builder, options, callback, dependencies) {
  return useQuery(builder, options, callback, dependencies);
}

export { useQueryBuilder };
//# sourceMappingURL=use-query-builder.js.map